import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var waistbandDrawcordIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.017.25a.76.76 0 0 1 .752.751c0 .933.071 2.291.17 3.854.222 3.507.563 8.535.553 18.145a.761.761 0 0 1-.752.75h-3.77a.752.752 0 0 1-.743-.63l-1.222-13.027v.03L10.743 23.12a.751.751 0 0 1-.742.63h-3.74A.761.761 0 0 1 5.51 23c0-9.61.341-14.638.562-18.145.1-1.563.17-2.921.17-3.854A.762.762 0 0 1 6.993.25Zm-.59 4.5H7.554v.205c-.22 3.387-.56 8.206-.56 17.295H9.39l1.122-12.398c.088-.77.72-1.364 1.493-1.403A1.585 1.585 0 0 1 13.5 9.782l1.122 12.468h2.367c-.02-9.089-.342-13.908-.56-17.295V4.75ZM22.13.46l.355.355c.355.352.353 1.063-.001 1.416l-1.768 1.768 1.768 1.768c.354.353.354 1.06 0 1.414l-.354.354-2.822-2.823a1.012 1.012 0 0 1 0-1.43L22.129.46ZM1.87.46l2.823 2.823a1.01 1.01 0 0 1 0 1.429L1.872 7.535l-.354-.354c-.354-.354-.354-1.061 0-1.414l1.768-1.768L1.518 2.23c-.354-.353-.357-1.064-.002-1.416L1.87.46Zm14.406 1.293H7.734c-.01.391-.06 1.038-.06 1.498h8.662c-.059-.46-.059-1.107-.059-1.498Z",
  fill: "currentColor"
}));

export { waistbandDrawcordIcon as default };
//# sourceMappingURL=waistbandDrawcordIcon.js.map
